<template>
    <div class="personalMain">
      <p class="current">当前位置：<span>个人中心</span><i class="el-icon-arrow-right"></i><span>设置</span></p>
      <div class="personal-box">
        <personalMenu></personalMenu>
        <div class="MainInfo">
          <div class="config-title">
            <p @click="handleActive(1)" :class="active == 1 ? 'activeColor': 'isColor'">个人资料</p>
            <p @click="handleActive(2)" :class="active == 2 ? 'activeColor': 'isColor'">登陆密码</p>
            <p @click="handleActive(3)" :class="active == 3 ? 'activeColor': 'isColor'">收货地址</p>
            <p @click="handleActive(5)" :class="active == 5 ? 'activeColor': 'isColor'">发票地址</p>
            <!-- <p @click="handleActive(4)" :class="active == 4 ? 'activeColor': 'isColor'">清除缓存</p> -->
          </div>
          <div class="config-cont" >
            <div v-show="active == 1">
                <div class="conts-itmes" >
                    <div class="itemsImage"></div>
            
                    <div>
                        <div class="cont-item">
                            <p class="item-title">推荐人</p>
                            <p></p>
                        </div>
                        <div class="cont-item">
                            <p class="item-title">昵称</p>
                            <el-input v-model="input" placeholder="请输入您的昵称"></el-input>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="active == 2">
                <resetPwd></resetPwd>
            </div>
            <div v-show="active == 3">
                <Address  class="addInfo"></Address>
            </div>
            <div v-show="active == 5">
                <addressInvoice  class="addInfo"></addressInvoice>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import personalMenu from './index.vue'
  import resetPwd from './resetpwd.vue'
  import Address from './address.vue'
  import addressInvoice from './addressInvoice.vue'
  export default {
    data(){
      return{
        active: 1,
        input: '',
        addressType: ''
      }
    },
    components:{
      personalMenu,
      resetPwd,
      Address,
      addressInvoice
    },
    methods: {
        handleActive(val){
            this.active = val
            if(val == 3){
              this.addressType = 1
            }else if(val == 5){
              this.addressType = 2
            }
        }
    },
    mounted(){
        
    },
    created(){
      localStorage.setItem('active','2-11')
    }
  }
  </script>
  
<style scoped>
  @import url(../../css/personal.css);
::v-deep .cont-item .el-input__inner{
  border: none !important;
}
.config-title{
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
  margin-bottom: 30px;
  padding: 10px 20px;
  
}
.config-cont{
  padding: 10px 20px;
}
.config-title p{
  font-size: 18px;
  cursor: pointer;
  padding: 0px 8px 15px 8px;
  margin-right: 30px;
  
}
.activeColor{
  font-weight: 700;
  color: #10aeff;
  border-bottom: 2px solid #10aeff;
}
.isColor{
  border-bottom: 0.5px solid #f2f2f2; 
}
.conts-itmes{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 770px;
  margin: 0 auto;
}
.cont-item{
  width: 560px;
  
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
  color: #666;
  border-bottom: 0.5px solid #f2f2f2;
  padding: 10px 0 10px 10px;
  margin-top: 5px;
  margin-bottom: 10px;
}

.item-title{
  width: 100px;
  margin-right: 30px;
}
@media screen and (min-width: 541px) {
  .itemsImage{
    width: 150px;height: 150px;
    background: #f1f1f1;
    border-radius: 15px;
    margin-right: 40px;
  }
  .addInfo{
    width: 770px;
  }
}
@media screen and (max-width: 540px) {

  .config-title p{
    font-size: 16px;
    padding: 0px 5px 15px 3px;
    margin-bottom: 10px;
    
  }
  .conts-itmes{
    display: block;
    width: 100%;
  }
  .itemsImage{
    width: 150px;height: 150px;
    background: #f1f1f1;
    border-radius: 15px;
    margin: 0px auto;
    margin-bottom: 20px;
  }
  .cont-item{
    width: 100%;
    font-size: 16px;
    padding: 10px 0 10px 0px;
  }
  .addInfo{
    width: 100%;
  }
}
@import url(../../css/personal540.css);
</style>